var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"topbar_box"},[_c('div',{staticClass:"topbar"},[_c('van-icon',{attrs:{"name":"arrow-left"},on:{"click":function($event){return _vm.$router.back()}}}),_c('div',{staticClass:"item_title"},[_vm._v(_vm._s(_vm.title))])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }